import { Temporal } from "temporal-polyfill";

// The selected month groups cycles by their start date; the event ledger uses
// calendar-month boundaries. Both resolve in New York, independently of the
// admin's browser timezone, so their displayed dates agree with the API.
export const USAGE_BILLING_TIMEZONE = "America/New_York";

/** Matches the API's BILLING_MONTH_INPUT_PATTERN: "YYYY-MM". */
export const USAGE_BILLING_MONTH_KEY_PATTERN = /^\d{4}-(0[1-9]|1[0-2])$/;

const MONTH_LABEL_FORMAT: Intl.DateTimeFormatOptions = {
  month: "long",
  year: "numeric",
};

const DATE_TIME_FORMAT: Intl.DateTimeFormatOptions = {
  month: "short",
  day: "numeric",
  year: "numeric",
  hour: "numeric",
  minute: "2-digit",
  timeZoneName: "short",
};

function toYearMonth(monthKey: string): Temporal.PlainYearMonth {
  return Temporal.PlainYearMonth.from(monthKey);
}

/** The billing month containing "now", as a "YYYY-MM" key. */
export function getCurrentUsageBillingMonthKey(): string {
  return Temporal.Now.plainDateISO(USAGE_BILLING_TIMEZONE)
    .toPlainYearMonth()
    .toString();
}

export function shiftUsageBillingMonthKey(
  monthKey: string,
  months: number,
): string {
  return toYearMonth(monthKey).add({ months }).toString();
}

export function isUsageBillingMonthBeforeCurrent(monthKey: string): boolean {
  return (
    Temporal.PlainYearMonth.compare(
      toYearMonth(monthKey),
      toYearMonth(getCurrentUsageBillingMonthKey()),
    ) < 0
  );
}

/** "September 2026" */
export function formatUsageBillingMonthLabel(monthKey: string): string {
  return toYearMonth(monthKey)
    .toPlainDate({ day: 1 })
    .toLocaleString("en-US", MONTH_LABEL_FORMAT);
}

/** "Sep 1, 2026, 12:15 AM EDT" — always in the billing timezone. */
export function formatUsageBillingDateTime(value: string | Date): string {
  const iso = value instanceof Date ? value.toISOString() : value;
  return Temporal.Instant.from(iso)
    .toZonedDateTimeISO(USAGE_BILLING_TIMEZONE)
    .toLocaleString("en-US", DATE_TIME_FORMAT);
}
